import React from 'react';
import SurveyAnalysisApp from './components/SurveyAnalysisApp';

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <SurveyAnalysisApp />
    </div>
  );
}

export default App;